import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { ductedRailCounts } from './ducted-rail-counts';
import SystemsCount from './systems-count';
import useDuctedRailSections from './use-ducted-rail-sections';

export default function DuctedSystemsCount() {
  const { sections } = useDuctedRailSections();
  const tailRevealed = useAppSelector(
    (state) => state.ui.ductedFilters.tailRevealed
  );
  const { shownCount, totalCount } = useMemo(
    () => ductedRailCounts(sections, tailRevealed),
    [sections, tailRevealed]
  );

  return (
    <SystemsCount
      shownCount={shownCount}
      totalCount={totalCount}
      testId='ducted-systems-count'
    />
  );
}
